import React, { useEffect, useState } from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { debounce, getPlaceholderName, toggleArraySingleValue } from "../utils/general";
import { useModalContext } from "./context/ModalProvider";
import apiClient from "../apiClient";
import { GROUP_CHILDREN_USERS } from "../apiClient/apiEndpoints";
import { USER_LIMIT } from "../constant/constants";
import BtnLoad from "../components/BtnLoad";

const { SearchBar, SimCheckBox, SkeltonResourceManage } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const AssignRoleUserModal = () => {
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);
  const { modalState, openModal, closeModal, handleLoading } = useModalContext();
  const [search, setSearch] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [usersList, setUsersList] = useState([]);
  const [checkedUsers, setCheckedUsers] = useState([]);
  const [toDelete, setToDelete] = useState([]);
  const { selectedUsers, uuid, roleName = "", handleRefreshTab, loading } = modalState;

  useEffect(() => {
    setCheckedUsers(selectedUsers);
  }, []);

  const handleCancelModal = () => {
    closeModal();
    setCheckedUsers(selectedUsers);
  };

  const handleCloseModal = () => {
    if (loading) return;
    handleLoading(true);
    handleRefreshTab(checkedUsers, toDelete);
  };

  const handleSelectUsers = (e, id) => {
    if (e.target.checked) {
      setToDelete((prevToDelete) => prevToDelete.filter((preId) => preId !== id));
    } else {
      setToDelete((prevToDelete) => [...prevToDelete, id]);
    }
    setCheckedUsers((pre) => toggleArraySingleValue(pre, id));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setSearchQuery(search);
    }, 500);
    return () => clearTimeout(timer);
  }, [search]);

  const getGroupChildrenUsers = async () => {
    try {
      let list = await apiClient.get(
        `${configData.config.UNO_URL}${GROUP_CHILDREN_USERS}/${userData.user.group.uuid}`,
        {
          params: {
            limit: USER_LIMIT,
            page: 1,
            search: searchQuery || null,
          },
        }
      );
      list = list.filter((user) => user.uuid !== userData.user.uuid);
      setUsersList(list);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getGroupChildrenUsers();
  }, [uuid, searchQuery]);

  const handleUpdateUserDebounce = debounce(handleCloseModal, 500);

  return (
    <>
      <div className="assignmodal p-3">
        <h6>Assign Role: {roleName} </h6>
        <div className="">
          <div className="searchwithborder seacrh-padding ">
            <SearchBar placeholder="Search..." value={search} onChange={(e) => setSearch(e.target.value)} />
          </div>
          {loading ? (
            <SkeltonResourceManage count="5" width="50px" height="50px" circle={true} />
          ) : (
            <>
              <div className="sharemodalcont">
                {usersList.map((user) => {
                  return (
                    <div className="d-flex align-items-center gap-2">
                      <SimCheckBox
                        checked={checkedUsers.includes(user.uuid)}
                        onChange={(e) => handleSelectUsers(e, user.uuid)}
                      />
                      <UserAvatar user={user} />
                      <div>
                        <h6 className="username m-0"> {user.name} </h6>
                        <p className="usermail m-0"> {user.email} </p>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
        <div className="modal-footer  justify-content-end p-0">
          <div className="modal-footer-btns gap-2">
            <button onClick={handleCancelModal} className="cancel">
              Cancel
            </button>
            <button className="save" onClick={handleUpdateUserDebounce}>
              {" "}
              {loading ? <BtnLoad /> : "Add"}{" "}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default AssignRoleUserModal;

export const UserAvatar = ({ user }) => {
  const [imageError, setImageError] = useState(false);
  return (
    <>
      {!imageError && user.avatar ? (
        <div className="thumnail">
          <img
            className="smallavatar"
            src={user.avatar}
            alt={user.name}
            onError={() => setImageError(true)}
            referrerPolicy="no-referrer"
          />
        </div>
      ) : (
        <span className="avatar-fallback">{getPlaceholderName(user.name)}</span>
      )}
    </>
  );
};
